module.exports = __webpack_public_path__ + "static/media/1614cba8-5fb8-412e-8c00-4126c3de8788.d4f6b359.jpg";